import { ResourceType } from '#/client/models';

interface PathProps {
  pageId: string;
  resourceId?: string;
  resourceType?: ResourceType;
  itemName?: string;
  itemId?: string;
}

// this should probably be aligned with what we're doing in menu utils
// (is that getNavigationTarget in Header/utils/menu.ts now?)
export function generatePagePathname({
  pageId,
  resourceId,
  resourceType,
  itemName,
  itemId,
}: PathProps) {
  if (!pageId) {
    return pageId;
  }

  // If the page ID starts with '/page' we seem to treat it as a browse page navigation
  if (pageId.startsWith('/page')) {
    return pageId;
  }

  // If we have resource type and ID, then we conclude that this is a details page navigation
  if (resourceType && resourceId) {
    const hasValidId = (itemId && itemId === resourceId) || !itemId;
    const slug = itemName && hasValidId ? `/${slugifyName(itemName)}` : '';

    return `/details/${pageId}/${resourceType}/${resourceId}${slug}`;
  }

  // Otherwise we'll treat it as a browse page ID
  return `/page/${pageId}`;
}

// prettier-ignore
const charMap = {
  from: 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;',
    to: 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------',
};
const charReplaceRegex = new RegExp(charMap.from.split('').join('|'), 'g');

export function slugifyName(name: string) {
  if (!name) {
    return '';
  }

  name = name
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(charReplaceRegex, (c) =>
      charMap.to.charAt(charMap.from.indexOf(c))
    ) // Replace special characters
    .replaceAll('&', '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word characters
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, ''); // Trim - from start of text

  // remove trailing dashes without regex to prevent catastrophic backtracking
  while (name.endsWith('-')) {
    name = name.slice(0, -1);
  }

  return name;
}
